import React, {useContext} from 'react'  
import ReturnsContext from '../../../context/ReturnsContext'

import Loader from '../../Loader/Loader';
import { useQuery } from "react-query";
import moment from "moment";  

import Modal from 'react-modal'; 
import ModalDetails from '../Order/Modals/details'
import { useTranslation } from 'react-i18next';

const ReturnsTable = () => {  

    let {
        page,
        limit,  
        fetchData 
    } = useContext(ReturnsContext)
    
    const {isSuccess, isLoading, isFetching, data} = useQuery( ['returns', page, limit ], ({ queryKey }) => fetchData(
        queryKey[1]
        ),{ keepPreviousData : true });

        const [t, i18n] = useTranslation('common'); 
        
    return( 
        <>  
        {isFetching && <Loader></Loader>}
        {isSuccess & !isFetching ?  
        <table className="table table-striped nowrap" >
            <thead>
                <tr> 
                <th>{t('app.OrderID')}</th> 
                <th>{t('app.Information')}</th>   
                <th>{t('app.OrderDate')}</th>
                <th>{t('app.Customer')}</th>
                {/* <th>{t('app.Phone')}</th> */}
                <th> {t('app.Total')}</th>       
                </tr>
            </thead>
                <tbody> 
                    {data.list.length > 0 ? 
                  
                    data.list.map(row =>   
                        <tr key={row.orderId} id={`${row.orderId}-element`}>
                            <td >
                                <span className="ml-4">
                                    <a
                                        href={`https://admin.shopify.com/store/my-budapester/orders/${row.orderId}`}
                                        target="_blank"
                                    >
                                        {row.orderId}
                                    </a>
                                </span>
                            </td>
                            {/* <td>{row.creditMemoId}</td> */}
                            <td>
                                {row.products.map(product => 
                                    <p><img src={`${product.thumbUrl}`} class="img-table-thumb"/>{`${product.qty} x ${product.sku} - ${product.size}`}</p>
                                )}
                            </td>
                            <td>{moment(row.saleTime).format("DD/MM/YY")}</td>
                            <td>{row.customer.shipping.name}</td>
                            {/* <td>{row.customer.shipping.phoneNumber}</td>  */}
                            <td>{row.sum.value}{row.sum.currency} </td> 
                        </tr>
                     )
                     :
                    <tr>
                        <td colSpan={9}><span className="ro-res"> No results</span></td> 
                    </tr>
                    }
                </tbody>
            </table>
           :"" }
         
          
        </>
    )
}
export default ReturnsTable